import { Empty, Spin } from "antd";
import React from "react";

interface ViewPDFProps {
  pdfUrl: string;
  height?: string;
}

const ViewPDF: React.FC<ViewPDFProps> = ({ pdfUrl, height = "800px" }) => {
  return (
    <div style={{ height: height }}>
      {pdfUrl ? (
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Pledge Ticket Preview"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <Spin spinning />
        </div>
      )}
    </div>
  );
};

export default ViewPDF;
